const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('cart-drawer', class extends Core {
    elements = {
        'modal': 'modal-container'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._handleCartUpdate, { global: true });
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_DRAWER_MUTE, this._handleMute, { once: true, global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });

        // Delegated listeners survive cart-live-region re-renders, so no
        // re-binding is needed after cart updates.
        this.addEventListener('click', this._handleClick.bind(this));
        this.addEventListener('keydown', this._handleKeydown.bind(this));

        this._watchDialogOpen();

        setTimeout(() => this._startTimer(), 500);
    }

    /* Adds a short-lived @entering class to the panel each time the dialog
       opens, driving the staggered fade-up of items/status/dock in CSS.
       Scoped to open events only, so qty-change re-renders don't re-animate. */
    _watchDialogOpen() {
        const dialog = this.querySelector('dialog');
        const root = this.querySelector('.\\#cart-drawer');
        if (!dialog || !root) return;

        new MutationObserver(() => {
            if (!dialog.open) return;
            root.classList.add('@entering');
            clearTimeout(this._enteringTimeout);
            this._enteringTimeout = setTimeout(() => root.classList.remove('@entering'), 1200);
        }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    _startTimer() {
        const duration = 10 * 60;
        let remaining = sessionStorage.getItem('cart-timer');
        remaining = remaining ? parseInt(remaining) : duration;

        const countdown = this.querySelector('[class*="cart-drawer-timer-countdown"]');
        if (!countdown) return;

        clearInterval(this._timerInterval);
        this._timerInterval = setInterval(() => {
            remaining--;
            if (remaining <= 0) {
                clearInterval(this._timerInterval);
                sessionStorage.removeItem('cart-timer');
                remaining = duration;
            }
            sessionStorage.setItem('cart-timer', remaining);
            const mins = String(Math.floor(remaining / 60)).padStart(2, '0');
            const secs = String(remaining % 60).padStart(2, '0');
            countdown.textContent = `${mins}:${secs}`;
        }, 1000);
    }

    _handleCartUpdate({ req }) {
        if (req === 'cartAdd') {
            this.$('modal').open();
        }
        sessionStorage.removeItem('cart-timer');
        setTimeout(() => this._startTimer(), 500);
    }

    _handleCartChange({ key }) {
        this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
        if (!this.updatingProduct) {
            return;
        }
        sessionStorage.removeItem('cart-timer');
        setTimeout(() => this._startTimer(), 500);
        $loading(this.updatingProduct);
    }

    _handleMute() {
        this.unsub(Events.CART_UPDATE);
    }

    _handleCartError() {
        this.updatingProduct && $loading(this.updatingProduct, false);
    }

    _handleClick(e) {
        const toggle = e.target.closest('[class*="cart-drawer-discount-toggle"]');
        if (toggle) {
            this._openDiscountField(toggle);
            return;
        }

        const apply = e.target.closest('[class*="cart-drawer-discount-apply"]');
        if (apply) {
            e.preventDefault();
            this._applyDiscount(apply);
            return;
        }

        const remove = e.target.closest('[class*="cart-drawer-applied-discount-remove"]');
        if (remove) {
            this._removeDiscount(remove);
            return;
        }

        const checkout = e.target.closest('[name="checkout"]');
        if (checkout) {
            checkout.classList.add('@checking-out');
        }
    }

    _openDiscountField(toggle) {
        const box = toggle.parentElement;
        if (!box) return;
        box.classList.add('@open');
        const input = box.querySelector('[class*="cart-drawer-discount-input"]');
        input && input.focus();
    }

    _handleKeydown(e) {
        // Enter inside the discount input must apply the code, not submit
        // the surrounding cart form (which navigates to the cart page).
        if (e.key !== 'Enter') return;
        if (!e.target.closest('[class*="cart-drawer-discount-input"]')) return;
        e.preventDefault();
        const apply = this.querySelector('[class*="cart-drawer-discount-apply"]');
        apply && this._applyDiscount(apply);
    }

    async _applyDiscount(btn) {
        if (btn.disabled) return;

        const input = this.querySelector('[class*="cart-drawer-discount-input"]');
        if (!input) return;

        const code = input.value.trim();
        if (!code) return;

        btn.disabled = true;
        btn.classList.add('@loading');

        try {
            const res = await fetch(`${window.dynamicURLs['cartUpdate']}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: code })
            });
            const cart = await res.json();

            // discount_codes carries per-code applicability; older API
            // versions without it fall back to checking for any discount.
            const applied = Array.isArray(cart.discount_codes)
                ? cart.discount_codes.some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable)
                : (cart.cart_level_discount_applications?.length > 0 || cart.total_discount > 0);

            btn.classList.remove('@loading');

            if (applied) {
                btn.textContent = 'Applied!';
                input.value = '';
                document.dispatchEvent(new CustomEvent('cart:refresh'));
            } else {
                btn.textContent = 'Invalid code';
                setTimeout(() => {
                    btn.textContent = 'Apply';
                    btn.disabled = false;
                }, 2000);
            }
        } catch (err) {
            btn.classList.remove('@loading');
            btn.textContent = 'Apply';
            btn.disabled = false;
        }
    }

    async _removeDiscount(btn) {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('@loading');

        try {
            await fetch(`${window.dynamicURLs['cartUpdate']}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            });
            document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) {
            btn.disabled = false;
            btn.classList.remove('@loading');
        }
    }
})
